module.exports = __webpack_public_path__ + "static/img/SCAT.72d543f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/SCAT.png
// module id = VUh6
// module chunks = 0